import { Scalar } from "../types/Scalar";
import { ZCmpOp } from "../types/ZCmpOp";

/* eslint eqeqeq: "off" */

export const cmpScalarValues = (
  op: ZCmpOp,
  left: Scalar,
  right: Scalar,
): boolean | undefined => {
  if (
    left === null ||
    left === undefined ||
    right === null ||
    right === undefined
  )
    return undefined;
  switch (op) {
    case "=":
      return left == right;
    case "!=":
      return left != right;
    case "<":
      return left < right;
    case ">":
      return left > right;
    case "<=":
      return left <= right;
    case ">=":
      return left >= right;
    default:
      break;
  }
  return false;
};
